import React from 'react';

function PaginationBar({ pagination = {}, loading = false, onPageChange, onLimitChange }) {
  const page = Number(pagination.page || 1);
  const limit = Number(pagination.limit || 25);
  const total = Number(pagination.total || 0);
  const totalPages = Math.max(Number(pagination.totalPages || Math.ceil(total / limit) || 1), 1);
  const start = total ? ((page - 1) * limit) + 1 : 0;
  const end = total ? Math.min(page * limit, total) : 0;

  return (
    <div className="att-pagination">
      <span>Showing {start}-{end} of {total}</span>
      <span>Page {page} / {totalPages}</span>
      <button className="att-btn" disabled={loading || page <= 1} onClick={() => onPageChange(page - 1)}>Previous</button>
      <button className="att-btn" disabled={loading || page >= totalPages} onClick={() => onPageChange(page + 1)}>Next</button>
      <label>
        Page size
        <select disabled={loading} value={limit} onChange={(e) => onLimitChange(Number(e.target.value))}>
          {[10, 25, 50, 100].map((size) => <option key={size} value={size}>{size}</option>)}
        </select>
      </label>
    </div>
  );
}

export default PaginationBar;
